import { render, staticRenderFns } from "./upDigitTest.vue?vue&type=template&id=18a8a13d&scoped=true"
import script from "./upDigitTest.vue?vue&type=script&lang=js"
export * from "./upDigitTest.vue?vue&type=script&lang=js"
import style0 from "./upDigitTest.vue?vue&type=style&index=0&id=18a8a13d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a8a13d",
  null
  
)

export default component.exports